import SubcategoryPage from '@/components/template/SubcategoryPage';

const GhostStool = () => {
  const products = [
    {
      title: "Ghost Stool Clear",
      imageSrc: "https://images.unsplash.com/photo-1551298370-9d3d53740c72?auto=format&fit=crop&q=80",
      url: "/proizvodi/ghost-stool-clear"
    },
    {
      title: "Ghost Stool Smoke",
      imageSrc: "https://images.unsplash.com/photo-1588866413115-47473525bfc4?auto=format&fit=crop&q=80",
      url: "/proizvodi/ghost-stool-smoke"
    },
    {
      title: "Ghost Stool Amber",
      imageSrc: "https://images.unsplash.com/photo-1528698827591-e19ccd7bc23d?auto=format&fit=crop&q=80",
      url: "/proizvodi/ghost-stool-amber"
    }
  ];

  return (
    <SubcategoryPage
      title="Ghost Stool"
      description="Prozorni in elegantni Ghost stolčki, ki ustvarijo iluzijo lebdenja in dodajo sodobno noto vašemu prostoru."
      heroImage="https://images.unsplash.com/photo-1551298370-9d3d53740c72?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default GhostStool;